import Card from "../common/components/Card";
import { createEpcr, useJobEpcrs } from "../reducers/epcrSlice";
import { EpcrListEntry } from "./epcr/EpcrListEntry";
import PropTypes from 'prop-types';
import { useSelectedPCR } from "../utils/CADStateProvider";
import { DefaultButton } from "../common/components/DefaultButton";
import useClientConfig from "../common/hooks/clientConfigHook";
import { now } from "../common/utils/CDate";
import useNetwork from "../common/hooks/networkHook";
import { readField, writeField } from "../common/utils/objectUtilities";
import { useType } from "../reducers/typeSlice";
import { deepClone } from "../common/utils/objectUtilities";
import { useSpecializedTranslation } from "../hooks/specializedTranslationHook";
import { useJob } from "../reducers/jobSlice";

export const JobEpcrs = ({ jobid, disabled = false, style }) => {
    const clientConfig = useClientConfig();
    const network = useNetwork();
    const { selectedPcrID, setSelectedPcrID } = useSelectedPCR();
    const pcrs = useJobEpcrs(jobid);
    const job = useJob(jobid);
    const type = useType(job?.site, job?.level, job?.type);
    const { t } = useSpecializedTranslation(job);


    const addEpcr = async () => {
        let data  = {creation: now(clientConfig.tz).toISOString(), jobid};
        Object.entries(clientConfig.linkJobAndePCRFields).forEach(([jobField, epcrField]) => {
            const value = readField(job, jobField)
            writeField(data, epcrField === true ? jobField : epcrField, value ? deepClone(value) : value);
        })
        const id = crypto.randomUUID();
        await createEpcr(network, { id, ...data });
        setSelectedPcrID(id);
    }

    // if the type is not enabled for PCRs then only show PCRs that have already been created under another type
    // otherwise if there are no PCRs there is nothing to render
    if (!type?.epcr) {
        if (pcrs?.length > 0) {
            return <>
                {pcrs.map(pcr => <EpcrListEntry key={pcr.id} epcr={pcr} disabled={disabled} onClick={() => setSelectedPcrID(selectedPcrID?.toString() === pcr.id.toString() ? null : pcr.id)}></EpcrListEntry>)}
            </>
        } else {
            return null;
        }
    }

    return <div className="d-flex flex-column px-2 pt-2" style={{ backgroundColor: '#31A38F', borderRadius: '8px' }}>
        <div className="text-end">
            <DefaultButton kind="add" confirmMessage={t('confirmEpcrCreate')} onClick={addEpcr} style={style}></DefaultButton>
        </div>
        <div className="mt-2">
            {pcrs.length > 0 ? null : <span style={{ color: 'white' }}>{t('noJobEpcrs')}</span>}
            {pcrs.map(pcr => <EpcrListEntry key={pcr.id} epcr={pcr} disabled={disabled} onClick={() => setSelectedPcrID(selectedPcrID?.toString() === pcr.id.toString() ? null : pcr.id)}></EpcrListEntry>)}
        </div>
    </div>
}

JobEpcrs.propTypes = {
    jobid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    style: PropTypes.object
}